// Bill date validation compares calendar days in the document timezone so UTC offsets cannot make
// two displayed dates validate in the opposite order.
import { DateTime } from 'luxon';

export const BILL_DUE_DATE_BEFORE_BILL_DATE_MESSAGE = 'Due Date cannot be earlier than Bill Date.';

export const BILL_DATE_IN_FUTURE_MESSAGE = 'Bill Date cannot be in the future.';

export function isDueDateBeforeBillDate(billDate: unknown, dueDate: unknown, timezone?: string): boolean {

  const bill = calendarDate(billDate, timezone);
  const due = calendarDate(dueDate, timezone);
  return !!bill && !!due && due < bill;
}

export function billCalendarIso(value: unknown, timezone?: string): string | undefined {

  return calendarDate(value, timezone) ?? undefined;
}

export function validateDueDateNotBeforeBillDate(value: unknown, timezone?: string): { valid: true } | { valid: false; code: string; message: string } {

  const [billDate, dueDate] = Array.isArray(value) ? value as [unknown, unknown] : [undefined, value];
  if (!isDueDateBeforeBillDate(billDate, dueDate, timezone)) return { valid: true };
  return { valid: false, code: 'dueDateNotBeforeBillDate', message: BILL_DUE_DATE_BEFORE_BILL_DATE_MESSAGE };
}

export function billTodayIso(timezone?: string, now: Date = new Date()): string {

  return DateTime.fromJSDate(now, { zone: timezone || 'utc' }).toISODate()!;
}

// Legacy capped the picker at today; typed or pasted dates must fail the same way on save. A date the
// record was saved with is left alone, so one already in the future (API import) can still be edited.
export function validateBillDateNotInFuture(value: unknown, timezone?: string, saved?: unknown, now: Date = new Date()): { valid: true } | { valid: false; code: string; message: string } {

  const [date] = Array.isArray(value) ? value as [unknown] : [value];
  const day = calendarDate(date, timezone);
  if (!day || day <= billTodayIso(timezone, now) || day === calendarDate(saved, timezone)) return { valid: true };
  return { valid: false, code: 'billDateNotInFuture', message: BILL_DATE_IN_FUTURE_MESSAGE };
}

function calendarDate(value: unknown, timezone?: string): string | null {

  if (value == null || value === '') return null;
  const zone = timezone || 'utc';
  if (value instanceof Date) {
    const dt = DateTime.fromJSDate(value, { zone });
    return dt.isValid ? dt.toISODate() : null;
  }
  if (typeof value === 'string') {
    const dt = DateTime.fromISO(value, { zone });
    return dt.isValid ? dt.toISODate() : null;
  }
  return null;
}
